/* My Acre - Configuration picker (2026-08-11, Claude)
   Renders the one wordy "Configuration" option as a richer control. It never
   replaces the Shopify radios, it DRIVES them: the original .option-values
   list stays in the DOM (hidden) and every selection sets checked = true and
   dispatches a bubbling change event, so variant resolution, pricing, the AR
   link, the mount rules and the chosen-value label all keep working.

   TWO MODES.

   1. ROW mode (the original, Shadowspec Unity). One row per value with a
      canopy-layout diagram, the short name, the canopy makeup and the shade
      area. Driven by custom.config_meta via window.MA_CONFIG_META.

   2. TILE mode (2026-09-09, Claude, Hayden approved). Four tiles across, each
      a solid silhouette of the actual product in that configuration, with the
      name and the price. Built for Ochre Living: the Perisher's four choices
      span $6,490 to $8,140 and only two of them have ever been photographed,
      so the picker showed the same picture across a $1,650 spread. Hayden
      picked the solid silhouette over a line drawing and over half-photographed
      tiles.

      The three fireplaces are genuinely different objects and each gets its own
      geometry, drawn from its own studio photograph: the PERISHER is wide with
      a deep firebox, the HOTHAM is the same family but narrower with a shorter
      chimney, and the OSSA is a slim tower standing on open legs whose side
      store is a low bench rather than a full-height box. One shape for all
      three would have been the easy version and a lie.

      HOW A PRODUCT OPTS IN. No metafield and no theme edit is required: the
      family is read from the product name and the configuration from the option
      value's own words, which already say exactly what they mean ("With under
      log store and one side log store"). window.MA_OPTION_ICONS still wins when
      present, so an explicit token can override the reading at any time.

      Token grammar, read as substrings so the set composes:
        <family>              perisher | hotham | ossa
        -under                adds the two under-firebox compartments
        -1side / -2side       adds a store to the right, or to both sides

      A tile takes a PHOTOGRAPH instead of the silhouette when the value appears
      in window.MA_OPTION_PHOTOS. That is how this upgrades itself the day Ochre
      send the two missing shots: data, not code.

   2026-08-13 (Claude): row overflow fix, see .ma-cfg__name ellipsis rules.
   Self-contained, no dependencies, fully wrapped in try/catch. */
(function () {
  try {
    var STYLE_ID = 'ma-config-picker-css';
    var FLAG = 'maConfigPicker';
    var SUFFIX = /\s*\(\s*\d+\s*canopies?\s*\)\s*$/i;
    var COUNT_RE = /\(\s*(\d+)\s*canopies?\s*\)/i;
    var TIMES = '×';
    var SQM = ' m²';
    var DOT = ' · ';

    var CSS = [
      '.ma-cfg{margin:0 0 2px;max-width:100%;overflow:hidden;--ma-stone:#D8D3CC;--ma-stone-deep:#B7B0A6;--ma-cavity:#3A3632;}',
      '.ma-cfg__list{display:grid;grid-template-columns:1fr 1fr;gap:7px;min-width:0;}',
      '@media (max-width:700px){.ma-cfg__list{grid-template-columns:1fr;}}',
      '.ma-cfg__row{display:flex;align-items:center;gap:12px;background:#fff;border:1.5px solid #D9D3CC;border-radius:10px;padding:9px 12px;width:100%;min-width:0;max-width:100%;overflow:hidden;box-sizing:border-box;text-align:left;color:#121417;font:inherit;cursor:pointer;-webkit-appearance:none;appearance:none;transition:border-color .15s ease,background-color .15s ease;}',
      '.ma-cfg__row:hover{border-color:#8A5A34;}',
      '.ma-cfg__row.is-selected{border-color:#8A5A34;background:rgba(138,90,52,.07);}',
      '.ma-cfg__row.is-disabled,.ma-cfg__row[disabled]{opacity:.4;cursor:not-allowed;}',
      '.ma-cfg__row.is-disabled:hover,.ma-cfg__row[disabled]:hover{border-color:#D9D3CC;}',
      '.ma-cfg__icon{flex:0 0 auto;color:#8A5A34;line-height:0;}',
      '.ma-cfg__icon svg{display:block;width:28px;height:28px;}',
      '.ma-cfg__mid{flex:1 1 auto;min-width:0;overflow:hidden;}',
      '.ma-cfg__name{display:block;font-size:13.5px;font-weight:600;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      '.ma-cfg__sub{display:block;font-size:11.5px;color:#4F525A;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      '.ma-cfg__area{flex:0 0 auto;display:block;font-size:14px;font-weight:700;color:#8A5A34;white-space:nowrap;text-align:right;}',
      '.ma-cfg__summary{margin-top:13px;padding:10px 13px;border:1px solid #E6E6E6;border-radius:10px;background:#FBFAF9;font-size:13px;line-height:1.4;color:#4F525A;}',
      '.ma-cfg__summary[hidden]{display:none;}',
      '.ma-cfg__summary b{color:#121417;font-weight:700;}',
      '.ma-cfg--tiles .ma-cfg__list{grid-template-columns:repeat(4,1fr);gap:10px;}',
      '@media (max-width:640px){.ma-cfg--tiles .ma-cfg__list{grid-template-columns:repeat(2,1fr);}}',
      '.ma-cfg__tile{display:flex;flex-direction:column;align-items:center;gap:8px;background:#fff;border:1.5px solid #E6E6E6;border-radius:10px;padding:10px 8px 12px;width:100%;min-width:0;box-sizing:border-box;text-align:center;color:#363D45;font:inherit;cursor:pointer;-webkit-appearance:none;appearance:none;transition:border-color .15s ease,box-shadow .15s ease;}',
      '.ma-cfg__tile:hover{border-color:#8A5A34;}',
      '.ma-cfg__tile.is-selected{border-color:#8A5A34;box-shadow:0 0 0 3px rgba(138,90,52,.22);}',
      '.ma-cfg__tile.is-disabled,.ma-cfg__tile[disabled]{opacity:.4;cursor:not-allowed;}',
      '.ma-cfg__face{width:100%;aspect-ratio:1/1;border-radius:7px;overflow:hidden;background:#FBFAF9;display:block;}',
      '.ma-cfg__face svg{display:block;width:100%;height:100%;}',
      '.ma-cfg__face img{display:block;width:100%;height:100%;object-fit:cover;}',
      '.ma-cfg__tname{display:block;font-size:11.5px;line-height:1.35;}',
      '.ma-cfg__tile.is-selected .ma-cfg__tname{color:#121417;font-weight:600;}',
      '.ma-cfg__price{display:block;font-size:11.5px;font-weight:600;color:#121417;font-variant-numeric:tabular-nums;}'
    ].join('');

    var SVG_2 = '<rect x="1.5" y="6.5" width="9" height="9"/><rect x="13.5" y="6.5" width="9" height="9"/>';
    var SVG_3 = '<rect x="1.5" y="1.5" width="9" height="9"/><rect x="13.5" y="1.5" width="9" height="9"/><rect x="1.5" y="13.5" width="9" height="9"/>';
    var SVG_4 = '<rect x="1.5" y="1.5" width="9" height="9"/><rect x="13.5" y="1.5" width="9" height="9"/><rect x="1.5" y="13.5" width="9" height="9"/><rect x="13.5" y="13.5" width="9" height="9"/>';
    var SVG_OCT = '<polygon points="10.6,14.4 7.6,17.4 3.4,17.4 0.4,14.4 0.4,10.2 3.4,7.2 7.6,7.2 10.6,10.2"/><polygon points="23.6,14.4 20.6,17.4 16.4,17.4 13.4,14.4 13.4,10.2 16.4,7.2 20.6,7.2 23.6,10.2"/>';

    var STONE = 'var(--ma-stone)';
    var DEEP = 'var(--ma-stone-deep)';
    var CAV = 'var(--ma-cavity)';

    function r(x, y, w, h, fill) {
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="' + fill + '"/>';
    }

    function wrapSvg(inner) {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 104" aria-hidden="true" focusable="false">' + inner + '</svg>';
    }

    /* Solid silhouettes, drawn to the proportions of each product's own studio
       photograph. STONE is the masonry, CAVITY is anything you can see into. */
    function silhouette(token) {
      var t = String(token || '').toLowerCase();
      var under = t.indexOf('under') !== -1;
      var sides = t.indexOf('2side') !== -1 ? 2 : (t.indexOf('1side') !== -1 ? 1 : 0);
      var s = '';

      if (t.indexOf('ossa') === 0) {
        s += r(46, 4, 20, 44, STONE);
        s += r(41, 48, 30, 30, STONE);
        s += r(46, 54, 20, 18, CAV);
        s += r(41, 78, 30, 4, DEEP);
        s += r(43, 82, 6, 14, STONE);
        s += r(63, 82, 6, 14, STONE);
        if (sides >= 1) { s += r(74, 76, 30, 20, STONE) + r(79, 81, 20, 12, CAV); }
        if (sides >= 2) { s += r(8, 76, 30, 20, STONE) + r(13, 81, 20, 12, CAV); }
        return wrapSvg(s);
      }

      if (t.indexOf('hotham') === 0) {
        s += r(50, 8, 20, 4, DEEP);
        s += r(53, 12, 14, 22, STONE);
        s += '<path d="M53 34h14l15 10H38z" fill="' + STONE + '"/>';
        s += r(38, 44, 44, 52, STONE);
        if (under) {
          s += r(44, 52, 32, 26, CAV) + r(44, 82, 14, 11, CAV) + r(62, 82, 14, 11, CAV);
        } else {
          s += r(44, 54, 32, 34, CAV);
        }
        if (sides >= 1) { s += r(86, 70, 26, 26, STONE) + r(91, 75, 16, 16, CAV); }
        if (sides >= 2) { s += r(8, 70, 26, 26, STONE) + r(13, 75, 16, 16, CAV); }
        return wrapSvg(s);
      }

      s += r(49, 4, 22, 4, DEEP);
      s += r(52, 8, 16, 26, STONE);
      s += '<path d="M52 34h16l18 10H34z" fill="' + STONE + '"/>';
      s += r(34, 44, 52, 52, STONE);
      if (under) {
        s += r(41, 52, 38, 26, CAV) + r(41, 82, 17, 11, CAV) + r(62, 82, 17, 11, CAV);
      } else {
        s += r(41, 54, 38, 34, CAV);
      }
      if (sides >= 1) { s += r(88, 68, 26, 28, STONE) + r(93, 74, 16, 17, CAV); }
      if (sides >= 2) { s += r(6, 68, 26, 28, STONE) + r(11, 74, 16, 17, CAV); }
      return wrapSvg(s);
    }

    function injectCss() {
      if (document.getElementById(STYLE_ID)) return;
      var s = document.createElement('style');
      s.id = STYLE_ID;
      s.appendChild(document.createTextNode(CSS));
      (document.head || document.documentElement).appendChild(s);
    }

    function norm(v) {
      return String(v === null || v === undefined ? '' : v).toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function str(v) {
      return String(v === null || v === undefined ? '' : v).trim();
    }

    function mapLookup(src) {
      var out = {};
      try {
        if (!src || typeof src !== 'object') return out;
        for (var k in src) {
          if (!Object.prototype.hasOwnProperty.call(src, k)) continue;
          out[norm(k)] = src[k];
        }
      } catch (e) { /* malformed: fall back */ }
      return out;
    }

    function metaLookup() {
      var out = {};
      try {
        var M = window.MA_CONFIG_META;
        if (!M || typeof M !== 'object') return out;
        for (var k in M) {
          if (!Object.prototype.hasOwnProperty.call(M, k)) continue;
          var v = M[k];
          if (v && typeof v === 'object') out[norm(k)] = v;
        }
      } catch (e) { /* metafield malformed: render names only */ }
      return out;
    }

    /* Which product this is, read from the page's own H1 so no metafield is
       needed. Only these three families have a drawn silhouette; anything else
       returns '' and the picker stays in row mode. */
    function familyOnPage() {
      var name = '';
      try {
        var h = document.querySelector('h1');
        name = norm((h && h.textContent) || document.title || '');
      } catch (e) { return ''; }
      if (name.indexOf('perisher') !== -1) return 'perisher';
      if (name.indexOf('hotham') !== -1) return 'hotham';
      if (name.indexOf('ossa') !== -1) return 'ossa';
      return '';
    }

    /* The option values say exactly what they mean, so the token is read from
       them: "With under log store and two side log stores" -> -under-2side. */
    function tokenFor(family, value) {
      var v = norm(value);
      var t = family;
      if (v.indexOf('under') !== -1) t += '-under';
      if (v.indexOf('two side') !== -1) t += '-2side';
      else if (v.indexOf('one side') !== -1) t += '-1side';
      return t;
    }

    /* The price shown on a tile. Read from the hidden variant <select>, whose
       option text is "<variant title> - <money>". Only matched when the variant
       title equals this option value, i.e. a single-option product, which is
       exactly the Ochre case. Anything else simply shows no price. */
    function priceLookup(container) {
      var out = {};
      try {
        var sel = container.querySelector('select[data-variants]');
        if (!sel) return out;
        var opts = sel.options;
        for (var i = 0; i < opts.length; i++) {
          var txt = (opts[i].textContent || '').replace(/\s+/g, ' ').trim();
          var cut = txt.lastIndexOf(' - ');
          if (cut === -1) continue;
          var title = txt.slice(0, cut).trim();
          var money = txt.slice(cut + 3).trim();
          if (title && money && !out[norm(title)]) out[norm(title)] = money;
        }
      } catch (e) { /* no prices, tiles still render */ }
      return out;
    }

    function iconFor(count, shape) {
      var inner = '';
      var extra = '';
      if (shape === 'octagon') {
        inner = SVG_OCT;
        extra = ' stroke-linejoin="miter"';
      } else if (count === 4) {
        inner = SVG_4;
      } else if (count === 3) {
        inner = SVG_3;
      } else if (count === 2) {
        inner = SVG_2;
      } else {
        return '';
      }
      return '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"' + extra + ' aria-hidden="true" focusable="false">' + inner + '</svg>';
    }

    function describe(raw, radio, lookup) {
      var it = { raw: raw, radio: radio, el: null, name: raw, count: 0, each: '', shape: '', area: '', sub: '' };
      it.name = raw.replace(SUFFIX, '').trim() || raw;

      var m = COUNT_RE.exec(raw);
      if (m) it.count = parseInt(m[1], 10) || 0;

      var meta = lookup[norm(raw)];
      if (meta) {
        var c = parseInt(meta.count, 10);
        if (c) it.count = c;
        it.each = str(meta.each);
        it.shape = norm(meta.shape);
        it.area = str(meta.area);
      }
      if (!it.shape && /octagon/i.test(raw)) it.shape = 'octagon';

      if (it.count && it.each && it.shape) {
        it.sub = it.count + ' ' + TIMES + ' ' + it.each + ' ' + it.shape + 's';
      }
      return it;
    }

    function build(container, fieldset) {
      if (fieldset.dataset[FLAG] === '1') return;

      var values = fieldset.querySelector('.option-values');
      if (!values) return;

      var radios = Array.prototype.slice.call(
        fieldset.querySelectorAll('input[type="radio"]')
      );
      if (radios.length < 2) return;

      var icons = mapLookup(window.MA_OPTION_ICONS);
      var photos = mapLookup(window.MA_OPTION_PHOTOS);
      var family = familyOnPage();
      var tileMode = !!family;
      var i;
      if (!tileMode) {
        for (i = 0; i < radios.length; i++) {
          if (icons[norm(radios[i].value)] || photos[norm(radios[i].value)]) { tileMode = true; break; }
        }
      }

      var lookup = metaLookup();
      var prices = tileMode ? priceLookup(container) : {};
      var items = [];
      for (i = 0; i < radios.length; i++) {
        var raw = (radios[i].value || '').trim();
        if (!raw) return; /* cannot label a row: leave the original picker */
        var it = describe(raw, radios[i], lookup);
        it.icon = icons[norm(raw)] || (family ? tokenFor(family, raw) : '');
        it.photo = photos[norm(raw)] || '';
        it.price = prices[norm(raw)] || '';
        items.push(it);
      }
      if (!items.length) return;

      fieldset.dataset[FLAG] = '1';
      injectCss();

      values.hidden = true;
      values.style.display = 'none';

      var wrap = document.createElement('div');
      wrap.className = 'ma-cfg' + (tileMode ? ' ma-cfg--tiles' : '');
      var list = document.createElement('div');
      list.className = 'ma-cfg__list';
      var summary = document.createElement('div');
      summary.className = 'ma-cfg__summary';
      wrap.appendChild(list);
      if (!tileMode) wrap.appendChild(summary);

      function select(radio) {
        if (!radio || radio.disabled) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      }

      function makeTile(it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ma-cfg__tile';

        var face = document.createElement('span');
        face.className = 'ma-cfg__face';
        if (it.photo) {
          var im = document.createElement('img');
          im.src = it.photo;
          im.alt = '';
          im.loading = 'lazy';
          face.appendChild(im);
        } else {
          face.innerHTML = silhouette(it.icon);
        }
        b.appendChild(face);

        var nm = document.createElement('span');
        nm.className = 'ma-cfg__tname';
        nm.textContent = it.name;
        b.appendChild(nm);

        if (it.price) {
          var pr = document.createElement('span');
          pr.className = 'ma-cfg__price';
          pr.textContent = it.price;
          b.appendChild(pr);
        }

        b.addEventListener('click', function () { select(it.radio); });
        it.el = b;
        return b;
      }

      function makeRow(it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ma-cfg__row';

        var svg = iconFor(it.count, it.shape);
        if (svg) {
          var ic = document.createElement('span');
          ic.className = 'ma-cfg__icon';
          ic.innerHTML = svg;
          b.appendChild(ic);
        }

        var mid = document.createElement('span');
        mid.className = 'ma-cfg__mid';
        var nm = document.createElement('span');
        nm.className = 'ma-cfg__name';
        nm.textContent = it.name;
        mid.appendChild(nm);
        if (it.sub) {
          var sb = document.createElement('span');
          sb.className = 'ma-cfg__sub';
          sb.textContent = it.sub;
          mid.appendChild(sb);
        }
        b.appendChild(mid);

        if (it.area) {
          var ar = document.createElement('span');
          ar.className = 'ma-cfg__area';
          ar.textContent = it.area + SQM;
          b.appendChild(ar);
        }

        b.addEventListener('click', function () { select(it.radio); });
        it.el = b;
        return b;
      }

      function renderSummary(it) {
        if (tileMode) return;
        summary.textContent = '';
        if (!it) {
          summary.hidden = true;
          return;
        }
        summary.hidden = false;
        var b = document.createElement('b');
        b.textContent = it.name;
        summary.appendChild(b);
        var tail = '';
        if (it.count && it.each && it.shape) {
          tail += DOT + it.count + ' ' + TIMES + ' ' + it.each + ' ' + it.shape + ' canopies';
        }
        if (it.area) {
          tail += DOT + 'about ' + it.area + SQM + ' of shade';
        }
        if (tail) summary.appendChild(document.createTextNode(tail));
      }

      function sync() {
        var chosen = null;
        var k;
        for (k = 0; k < items.length; k++) {
          if (items[k].radio.checked) chosen = items[k];
        }
        for (k = 0; k < items.length; k++) {
          var it = items[k];
          if (!it.el) continue;
          var dis = !!it.radio.disabled;
          it.el.disabled = dis;
          if (dis) {
            it.el.classList.add('is-disabled');
            it.el.setAttribute('aria-disabled', 'true');
          } else {
            it.el.classList.remove('is-disabled');
            it.el.removeAttribute('aria-disabled');
          }
          var sel = (it === chosen);
          if (sel) {
            it.el.classList.add('is-selected');
          } else {
            it.el.classList.remove('is-selected');
          }
          it.el.setAttribute('aria-pressed', sel ? 'true' : 'false');
        }
        renderSummary(chosen);
      }

      for (i = 0; i < items.length; i++) {
        list.appendChild(tileMode ? makeTile(items[i]) : makeRow(items[i]));
      }

      var legend = fieldset.querySelector('legend');
      if (legend && legend.parentNode === fieldset) {
        fieldset.insertBefore(wrap, legend.nextSibling);
      } else {
        values.parentNode.insertBefore(wrap, values);
      }

      container.addEventListener('change', function () { sync(); });

      sync();
    }

    function scan() {
      var containers = document.querySelectorAll('[data-product-options-container]');
      Array.prototype.forEach.call(containers, function (container) {
        var sets = container.querySelectorAll('fieldset');
        Array.prototype.forEach.call(sets, function (fs) {
          /* An option already rendered as photo cards by snippets/ma-option-cards.liquid
             owns itself. Without this guard both controls render for the same option and
             the shopper sees the choice twice: found 10 Sep 2026 on the Aquascape ASA
             aerators, whose Shopify option is also literally named "Configuration". This
             picker was built for the Ochre Perisher and matched on that name alone. */
          if (fs.hasAttribute('data-ma-cards')) return;
          var nameEl = fs.querySelector('.option-name');
          var label = nameEl ? (nameEl.textContent || '').trim().toLowerCase() : '';
          if (label !== 'configuration') return;
          try {
            build(container, fs);
          } catch (err) { /* never break the page */ }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', scan);
  } catch (e) { /* never break the page */ }
})();